"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.App = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _reactRouterDom = require("react-router-dom");

var _constants = require("../constants");

var _Article = _interopRequireDefault(require("../routes/Article"));

var _Home = _interopRequireDefault(require("../routes/Home"));

var _Topic = _interopRequireDefault(require("../routes/Topic"));

var _SearchResults = _interopRequireDefault(require("../routes/SearchResults"));

var _actions = require("../store/actions");

var _Footer = _interopRequireDefault(require("./Footer"));

var _Navigation = _interopRequireDefault(require("./Navigation"));

var _Search = _interopRequireDefault(require("./Search"));

var _Style = _interopRequireDefault(require("./Style"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var App =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(App, _PureComponent);

  function App(props) {
    var _this;

    _classCallCheck(this, App);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(App).call(this, props));

    _this.setIncomingProps(props, {});

    return _this;
  }

  _createClass(App, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      this.setIncomingProps(this.props, prevProps);
      var location = this.props.location;

      if (location !== prevProps.location) {
        this.props.searchSuggestionsClear();
      }
    }
  }, {
    key: "setIncomingProps",
    value: function setIncomingProps(props, prevProps) {
      if (props.env !== prevProps.env) {
        props.appEnvSet(props.env);
      }

      if (props.market !== prevProps.market) {
        props.appClear();
        props.articleClear();
        props.searchResultsClear();
        props.searchSuggestionsClear();
        props.topicsClear();
        props.appEnvSet(props.env);
        props.appMarketSet(props.market);
      } else {
        var history = this.props.history;
        this.props.appHistoryEntriesSet(history.entries.map(function (entry) {
          return entry.pathname;
        }));
        this.props.appHistoryIndexSet(history.index);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: _constants.CLASS_APP_CONTAINER
      }, _react.default.createElement("div", {
        className: "help--app-top"
      }, _react.default.createElement(_Search.default, null), _react.default.createElement(_Navigation.default, null)), _react.default.createElement("div", {
        className: "help--app-content"
      }, _react.default.createElement(_reactRouterDom.Switch, null, _react.default.createElement(_reactRouterDom.Route, {
        exact: true,
        path: "/",
        component: _Home.default
      }), _react.default.createElement(_reactRouterDom.Route, {
        path: "/topic/:id",
        component: _Topic.default
      }), _react.default.createElement(_reactRouterDom.Route, {
        path: "/article/:id",
        component: _Article.default
      }), _react.default.createElement(_reactRouterDom.Route, {
        path: "/search/:query/:page",
        component: _SearchResults.default
      }), _react.default.createElement(_reactRouterDom.Route, {
        path: "/*",
        component: _Home.default
      }))), _react.default.createElement("div", null, _react.default.createElement(_Footer.default, null)), _react.default.createElement(_Style.default, {
        css: "\n          .".concat(_constants.CLASS_APP_CONTAINER, " {\n            bottom: 0;\n            display: flex;\n            flex-direction: column;\n            font-size: 14px;\n            left: 0;\n            overflow-y: scroll;\n            position: absolute;\n            top: 0;\n            width: 100%;\n          }\n\n          .help--app-top {\n            position: -webkit-sticky;\n            position: sticky;\n            top: 0;\n            z-index: 1;\n          }\n\n          .help--app-content {\n            flex: 1 0 auto;\n            overflow-x: hidden;\n          }\n        ")
      }), _react.default.createElement(_Style.default, {
        css: "\n          .".concat(_constants.CLASS_APP_CONTAINER, " .ux-accordion .panel {\n            padding-left: 1.5em;\n            padding-right: 1.5em;\n          }\n\n          .").concat(_constants.CLASS_APP_CONTAINER, " .ux-accordion .panel-title {\n            font-size: 1.25em;\n          }\n\n          .").concat(_constants.CLASS_APP_CONTAINER, " .ux-accordion .panel-collapse {\n            background-color: transparent;\n          }\n\n          .").concat(_constants.CLASS_APP_CONTAINER, " .ux-accordion .panel-content {\n            margin: 0;\n            margin-bottom: 30px;\n          }\n        ")
      }));
    }
  }]);

  return App;
}(_react.PureComponent);

exports.App = App;
App.propTypes = {
  appEnvSet: _propTypes.default.func.isRequired,
  appHistoryEntriesSet: _propTypes.default.func.isRequired,
  appHistoryIndexSet: _propTypes.default.func.isRequired,
  appMarketSet: _propTypes.default.func.isRequired,
  appClear: _propTypes.default.func.isRequired,
  env: _propTypes.default.string.isRequired,
  history: _propTypes.default.object.isRequired,
  market: _propTypes.default.string,
  location: _propTypes.default.object.isRequired,
  searchSuggestionsClear: _propTypes.default.func.isRequired
};
var mapDispatchToProps = {
  appClear: _actions.appClear,
  appEnvSet: _actions.appEnvSet,
  appHistoryEntriesSet: _actions.appHistoryEntriesSet,
  appHistoryIndexSet: _actions.appHistoryIndexSet,
  appMarketSet: _actions.appMarketSet,
  articleClear: _actions.articleClear,
  searchResultsClear: _actions.searchResultsClear,
  searchSuggestionsClear: _actions.searchSuggestionsClear,
  topicsClear: _actions.topicsClear
};

var _default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(null, mapDispatchToProps)(App));

exports.default = _default;